<template>
  <Body class="page-about" />

  <section class="section-intro">
    <div class="headline flex-center flex-column tit-flower">
      <h1 class="subtit">
        <RibbonLottie />
        <!-- <img
          class="img"
          src="/images/about/about_1_tit.svg"
          alt="‘어머니 사랑과 평화의 날’ & UN ‘국제 관용의 날’ 기념 캠페인"
        /> -->
        <span class="blind">‘어머니 사랑과 평화의 날’ & UN ‘국제 관용의 날’ 기념 캠페인</span>
      </h1>
      <!-- <h1 class="title">
        <img
          class="img"
          src="/images/headline_welcome.svg"
          alt="2024 평화를 부르는 ‘어머니 사랑의 언어’"
        />
        <span class="blind">2024 평화를 부르는 ‘어머니 사랑의 언어’</span>
      </h1> -->
      <div class="text">
        <p
          v-html="
            $t('세상에태어나처음받은어머니의사랑br자녀향한무조건적인지지와배려희생과섬김은br국가민족문화를넘어인')
          "
        />

        <p
          v-html="$t('올해로설립60주년을맞은하나님의교회세계복음선교협회는br11월1일을b어머니사랑과평화의날b로지정')"
        />

        <p v-html="$t('캠페인2주년인2026년에는평화를부르는어머니사랑의언어를br기존7가지에서9가지로확대해소통의깊이')" />

        <p v-html="$t('이캠페인은unbahrefhttpswwwunescoorgendaystolerance국제관용의')" />
      </div>

      <div class="flower flower-left">
        <div class="left1 ani" />
        <div class="left2 ani" />
        <div class="left3 ani" />
        <div class="left4 ani" />
        <div class="left5 ani" />
        <div class="left6 ani" />
        <div class="left7 ani" />
        <div class="left8 ani" />
      </div>

      <div class="flower flower-right">
        <div class="right1 ani" />
        <div class="right2 ani" />
        <div class="right3 ani" />
        <div class="right4 ani" />
        <div class="right5 ani" />
        <div class="right6 ani" />
      </div>
    </div>
  </section>

  <!-- <AboutYoutubeSection v-if="data?.videos && data.videos.length > 0" :videos="data?.videos ?? []" /> -->

  <section class="section-topic">
    <div class="headline flex-center flex-column">
      <!-- 한국어 -->
      <h3 v-if="locale === 'ko'">
        <picture class="img">
          <source media="(max-width:1069px)" srcset="/images/about/about_2_tit_m_new.svg">
          <img src="/images/about/about_2_tit_new.svg" alt="올해의 주제는 평화를 부르는 ‘어머니 사랑의 언어’>입니다.">
        </picture>
        <span class="blind">올해의 주제는 평화를 부르는 ‘어머니 사랑의 언어’입니다.</span>
      </h3>
      <!-- 다국어용 : 한국어 외에는 텍스트로 들어가요 -->
      <h3 v-else style="white-space: pre-line;">
        {{ aboutTopicHeadlineText }}
      </h3>
      <p v-html="$t('이해와배려가담긴따뜻한말brclassbrm어머니사랑의언어로소통해보세요brclassbrnone')" />
      <!-- <div class="date">{{ $t('집중실천기간') }} {{ $t('20241111231') }}</div> -->
    </div>

    <!-- 7가지 내용 소개 -->
    <div class="language-intro">
      <div class="card card1">
        <div class="title">
          <h4><span v-html="$t('b01b')" /><span v-html="$t('안녕하세요')" /></h4>
          <div class="sub" v-html="$t('평화를여는첫마디')" />
        </div>
        <p
          v-html="
            $t('엘리베이터에서만난이웃복도에서만난친구동네를가꾸고지키는고마운분들br매일보는사람평소스치듯지나친이')
          "
        />
      </div>
      <div class="card card2">
        <h4>
          <span v-html="$t('b02b')" />
          <span v-html="$t('고마워요덕분이에요애쓰셨어요')" />
        </h4>
        <div class="sub" v-html="$t('작은수고와배려에도고마움을표현해보세요')" />
        <p
          v-html="
            $t('나를위해따뜻한밥을차려준손길목적지까지br안전히운행해준친절에고마움을표현해보세요br따스한마음이오')
          "
        />
      </div>
      <div class="card card3">
        <h4><span v-html="$t('b03b')" /><span v-html="$t('내가미안해요힘들었죠')" /></h4>
        <div class="sub" v-html="$t('마음을녹이는한마디상대를먼저이해해보세요')" />
        <p
          v-html="
            $t('누군가와평화로운관계가필요한가요br상대의입장에서내말과행동을돌아보면어떨까요br내실수에대해사과하')
          "
        />
      </div>

      <div class="card card4">
        <h4><span v-html="$t('b04b')" /><span v-html="$t('괜찮아요그럴수있어요')" /></h4>
        <div class="sub" v-html="$t('허물을감싸주는한마디')" />
        <p v-html="$t('누구나실수할수있습니다br난처한상황에놓인상대를너그러이포용해주세요')" />
      </div>
      <div class="card card5">
        <h4><span v-html="$t('b05b')" /><span v-html="$t('먼저하세요')" /></h4>
        <div class="sub" v-html="$t('조급할수록여유를갖고양보하면어떨까요')" />
        <p
          v-html="
            $t('지하철개찰구마트계산대운전대앞모두가바쁜상황에서먼저양보해보세요br잠깐의여유가오늘하루를평화롭게합')
          "
        />
      </div>
      <div class="card card6">
        <h4><span v-html="$t('b06b')" /><span v-html="$t('당신의생각을더듣고싶어요')" /></h4>
        <div class="sub" v-html="$t('의견이다를때상대의말에더귀기울여주세요')" />
        <p
          v-html="
            $t('서로의견이달라자신의의견을내세우는상황br나의말을잠시멈추고경청해주세요br상대에대한존중과배려가소')
          "
        />
      </div>
      <div class="card card7">
        <h4>
          <span v-html="$t('b07b')" />
          <span v-html="$t('기도응원할게요잘될거예요')" />
        </h4>
        <div class="sub" v-html="$t('진심어린지지와응원을보내주세요')" />
        <p
          v-html="
            $t('나를지지하고응원하는사람이있다는사실은어떤상황에서도힘이됩니다힘겨운상황에놓여있는이에게진심어린지지')
          "
        />
      </div>

      <!-- 아래 신규 추가 : 배려, 칭찬 -->

      <div class="card card8">
        <h4>
          <span v-html="$t('b08b')" />
          <span v-html="$t('제가도울일은없나요')" />
        </h4>
        <div class="sub" v-html="$t('주변을살피는관심에서배려가시작됩니다')" />
        <p
          v-html="
            $t('무거운짐을든어르신바쁜동료어려움을겪는이웃에게도움의손길을내밀어보세요br작은손길이라도누군가에게큰')
          "
        />
      </div>
      <div class="card card9">
        <h4>
          <span v-html="$t('b09b')" />
          <span v-html="$t('대단해요잘하고있어요')" />
        </h4>
        <div class="sub" v-html="$t('따뜻한칭찬은서로에게행복을가져다줍니다')" />
        <p
          v-html="$t('상대의수고와노력작은변화에칭찬을건네보세요br그한마디가받는사람하는사람모두를활짝웃게합니다')"
        />
      </div>

      <div class="language-txt">
        <!-- 한국어 -->
        <picture v-if="locale === 'ko'" class="img">
          <source media="(max-width:767px)" srcset="/images/about/about_language_txt_m.svg">
          <img
            class="img"
            src="/images/about/about_language_txt.svg"
            alt="오늘 하루, ‘어머니 사랑의 언어’로 평화를 이뤄보세요."
          >
        </picture>
        <!-- 다국어용 : 한국어 외에는 텍스트로 들어가요 -->
        <div v-else class="tit" v-html="$t('오늘하루어머니사랑의언어로평화를이뤄보세요')" />
        <NuxtLink :to="$localePath('/checklist')" class="btn-line">
          {{ $t('캠페인참여하기') }}
        </NuxtLink>
      </div>
    </div>

    <div class="illust top" />
    <div class="illust bottom">
      <div class="illust center" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { HmlAboutScreenDataModel } from '~/types/models/models'
// GSAP
import gsap from 'gsap'

const { data } = await useAPI<HmlAboutScreenDataModel>('/hml/v1/screens/about', {
  method: 'GET',
  query: {
    languageGbSn: useI18n().locale,
  },
})

const { $t } = useNuxtApp()

const { locale } = useI18n()
const aboutTopicHeadlineText = computed(() =>
  String($t('2024년의주제는평화를부르는어머니사랑의언어입니다')).replace(/<br\s*\/?>/gi, '\n'),
)

// Head,Body
useHead({
  title: `${$t('소개')} - ${$t('어머니사랑과평화의날캠페인')}`,
  link: [{ rel: 'stylesheet', href: `/css/about.css?${useBuildTime()}` }],
})

onMounted(() => {
  // 타임라인 생성
  const tl1 = gsap.timeline()
  tl1.add('title-start')

  // 서브 타이틀 애니메이션 추가
  tl1.from(
    '.section-intro .subtit',
    {
      opacity: 0,
      y: 20,
      duration: 0.8,
      ease: 'power1.out',
    },
    'title-start',
  )

  // 타이틀 애니메이션 추가
  tl1.from(
    '.section-intro .title',
    {
      opacity: 0,
      y: 30,
      duration: 1,
      ease: 'power1.out',
    },
    'title-start+=0.2',
  )

  // 설명 문구 애니메이션과 꽃 애니메이션을 동시에 시작
  tl1.from(
    '.section-intro .text p',
    {
      opacity: 0,
      y: 30,
      duration: 0.8,
      ease: 'power1.out',
      stagger: 0.2,
    },
    'title-start+=0.4',
  )

  // 왼쪽 꽃 애니메이션 (역순 적용, 텍스트와 함께 시작)
  tl1.staggerFrom(
    gsap.utils.toArray('.flower-left .ani').reverse(), // 왼쪽 꽃을 역순으로 선택
    1.5,
    {
      opacity: 0,
      scale: 0,
      x: 30,
      ease: 'elastic.out(1, 0.5)',
    },
    0.08,
    'title-start', // 설명 문구와 같은 타이밍에 시작
  )

  // 오른쪽 꽃 애니메이션 (왼쪽 꽃과 함께 시작)
  tl1.staggerFrom(
    '.flower-right .ani',
    1.5,
    {
      opacity: 0,
      scale: 0,
      x: -30,
      ease: 'elastic.out(1, 0.5)',
    },
    0.08,
    'title-start+=0.6', // 왼쪽 꽃과 거의 동시에 시작되도록 조정
  )
})
</script>
